import { faAt, faCalendar, faStethoscope, faUser } from '@fortawesome/pro-solid-svg-icons'
import { Select } from 'antd'
import { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'

import FormItem from '../../../Components/shared/Forms/FormItem'
import Mailing from '../../../Components/shared/Mailing'
import SectorsSelector from '../../../Components/shared/Selectors/SectorsSelector'
import { EUROPEAN_DATE } from '../../../utils/constants'
import { isObject } from '../../../utils'
import { selectUser } from '../../../reducers/UserReducer'
import { getInstitutionSectors } from '../../../utils/api/institution'

const AcceptIndividualInternshipRequestForm = ({ sectors = [], student, request, onSectorSelect, onPeriodsSelect }) => {
  const user = useSelector(selectUser)

  const [institutionSectors, setInstitutionSectors] = useState(sectors)

  useEffect(() => {
    if (sectors.length === 0 && isObject(request.institution)) {
      getInstitutionSectors(user, request.institution).then(({ data }) => setInstitutionSectors(data))
    }
  }, [sectors.length, user, request.institution])

  const sectorsList = sectors.length > 0 ? sectors : institutionSectors

  return (
    <div className='h-100 w-100 flex-column'>
      <div className='flex-row w-100'>
        <FormItem className='w-50 pdr-4' icon={faUser} label='form.label.firstname'>
          <div className='pdl-8 fake-gray-input w-100'>
            {student.firstname}
          </div>
        </FormItem>
        <FormItem className='w-50 pdl-4' icon={faUser} label='form.label.lastname'>
          <div className='pdl-8 fake-gray-input w-100'>
            {student.lastname}
          </div>
        </FormItem>
      </div>
      <FormItem icon={faAt} label='form.label.email'>
        <div className='pdl-8 fake-gray-input w-100'>
          <Mailing email={student.email} />
        </div>
      </FormItem>
      <FormItem icon={faStethoscope} label='form.label.sector' required>
        <SectorsSelector
          style={{ width: '100%' }}
          values={sectorsList.length === 0 ? request.sector?.name : (request.sector?.id ?? null)}
          sectors={sectorsList}
          onChange={onSectorSelect}
          disabled={isObject(request?.sector)}
        />
      </FormItem>
      <FormItem icon={faCalendar} label='form.label.period' required>
        <Select className='w-100' onChange={onPeriodsSelect} mode='multiple'>
          {request.requestPeriods.map(p => <Select.Option key={p.id} value={p.id}> {p.startDate.format(EUROPEAN_DATE) + ' - ' + p.endDate.format(EUROPEAN_DATE)} </Select.Option>)}
        </Select>
      </FormItem>
    </div>
  )
}

export default AcceptIndividualInternshipRequestForm
